export const NULL_AS_STRING = "null"